import instance from "..";
import { createQueryString } from "src/utils/helper";
import { setCamerasList } from "src/reducers/cameras";
import { dummyCameras } from "src/constants/dummyCameras";

// ✅ SAFE ID
const extractId = (input: any): string | null => {
  if (!input) return null;
  if (typeof input === "string") return input;
  if (typeof input === "object" && input.id) return input.id;
  return null;
};

// ✅ GET CAMERAS
export const getCamerasListAction: any =
  (apiData) => async (dispatch: any) => {
    try {
      const query = createQueryString(apiData);

      const res = await instance.get(`/api/v1/admin/cameras?${query}`);
      const apiResponse = res?.data;

      if (
        !apiResponse?.success ||
        !apiResponse?.data ||
        !apiResponse?.data?.data
      ) {
        dispatch(setCamerasList(dummyCameras));
        return dummyCameras;
      }

      const formattedData = {
        data: apiResponse.data.data.map((item: any) => ({
          id: item.id,
          cameraNumber: item.cameraNumber,
          cameraKey: item.cameraKey,
          simNumber: item.simNumber,

          // 🔥 captain → driver mapping
          driverId: item?.captain?.id,
          driverName: item?.captain?.fullName,

          // 🔥 status string → number
          status:
            item.status === "Active" || item.status === true ? 1 : 0,

          createdOn: item.createdAt,
        })),
        total: apiResponse.data.total,
      };

      dispatch(setCamerasList(formattedData));
      return formattedData;
    } catch {
      dispatch(setCamerasList(dummyCameras));
      return dummyCameras;
    }
  };

// ✅ ADD CAMERA
export const addCameraAction: any =
  (payload) => async () => {
    try {
      const formattedPayload = {
        captainId: payload.driverId,
        cameraNumber: payload.cameraNumber,
        cameraKey: payload.cameraKey,
        simNumber: payload.simNumber,
        streamingUrl: "", // optional (not in UI)
      };

      const res = await instance.post(
        `/api/v1/admin/cameras`,
        formattedPayload
      );

      return res.data;
    } catch (err: any) {
      throw err?.response?.data || err;
    }
  };

// ✅ TOGGLE STATUS
export const updateCameraStatusAction: any =
  (input: any) => async () => {
    try {
      const id = extractId(input);
      if (!id) throw new Error("Invalid camera id");

      const res = await instance.put(
        `/api/v1/admin/cameras/${id}/toggle-status`
      );

      return res.data;
    } catch (err: any) {
      throw err?.response?.data || err;
    }
  };

// ✅ DELETE CAMERA
export const deleteCameraAction: any =
  (input: any) => async () => {
    try {
      const id = extractId(input);
      if (!id) throw new Error("Invalid camera id");

      const res = await instance.delete(
        `/api/v1/admin/deleteCamera/${id}`
      );

      return res.data;
    } catch (err: any) {
      throw err?.response?.data || err;
    }
  };

  // ✅ GET CAPTAINS DROPDOWN
export const getCaptainsDropdownAction: any = () => async () => {
  try {
    const res = await instance.get(`/api/v1/admin/captains/dropdown`);

    const apiResponse = res?.data;

    if (!apiResponse?.success || !apiResponse?.data) {
      return [];
    }

    // ✅ Format for dropdown
    return apiResponse.data.map((item: any) => ({
      label: `${item.fullName} (${item.phone})`,
      value: item.id,
      name: item.fullName,
      phone: item.phone,
    }));
  } catch (err: any) {
    throw err?.response?.data || err;
  }
};

// ✅ ASSIGN CAPTAIN TO CAMERA
export const assignCaptainToCameraAction: any =
  ({ cameraId, captainId }) =>
  async () => {
    try {
      if (!cameraId || !captainId) {
        throw new Error("Invalid cameraId or captainId");
      }

      const res = await instance.put(
        `/api/v1/admin/cameras/${cameraId}/assign-captain?captainId=${captainId}`
      );

      return res.data;
    } catch (err: any) {
      throw err?.response?.data || err;
    }
  };